import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { applyPriceTemplate, findProductFeedMinimalPrice, weeePricesToTextArray, format, } from '@pes-ui/utils';
import { isCategoryProduct } from '../guards';
export class MenuCardPrices {
  constructor() {
    this.getMinimalPriceByProductId = (id) => {
      var _a;
      const product = (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => product.ProductId === id);
      const price = findProductFeedMinimalPrice(product);
      if (!price) {
        return;
      }
      const { options: { countryLanguageCode, priceTemplate }, } = this.commerceConnectorSettings;
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.item = undefined;
    this.productsFeed = undefined;
    this.commerceConnectorSettings = undefined;
  }
  hasProductsFeed() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  renderWeeePrices() {
    if (!isCategoryProduct(this.item)) {
      return null;
    }
    return weeePricesToTextArray(this.item.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  render() {
    var _a, _b;
    if (!isCategoryProduct(this.item) && !this.hasProductsFeed()) {
      return;
    }
    if (this.hasProductsFeed()) {
      const minimalProductPrice = this.getMinimalPriceByProductId(this.item.id);
      return (minimalProductPrice && (h("div", { class: "menu-card-price menu-card-price--multi-line" }, h("div", { class: "menu-card-price__label", innerHTML: this.commerceConnectorSettings.labels.priceFrom }), h("span", { class: "menu-card-price__text", innerHTML: minimalProductPrice }))));
    }
    if (isCategoryProduct(this.item)) {
      const priceText = `${this.item.price}&nbsp;${this.item.currency}`;
      return (h("div", { class: "menu-card-price" }, h("span", { class: "menu-card-price__text", innerHTML: priceText }), !isEmpty((_b = (_a = this.item) === null || _a === void 0 ? void 0 : _a.weeePrices) !== null && _b !== void 0 ? _b : {}) && (h("pdp-icon-tooltip", { class: "menu-card-price__tooltip", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top" }, this.renderWeeePrices()))));
    }
  }
  static get is() { return "pes-menu-card-prices"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["menu-card-prices.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["menu-card-prices.css"]
    };
  }
  static get properties() {
    return {
      "item": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "| CategoriesApi.ProductsAllToprunners\n  | CategoriesApi.ProductsAllCategoriesCategoryProduct",
          "resolved": "{ brandImageUrl?: string; brandImageAltText?: string; badge?: Badge; count?: number; description?: string; domainName?: string; id?: string; longDescription?: string; name?: string; pictureUrl?: string; redirectUrl?: string; simpleName?: string; smallPictureUrl?: string; sourceId?: string; type?: string; url?: string; commercialStatus?: CommercialStatus; brandLogo?: TBrandLogo; } | { currency?: string; description?: string; id?: string; longDescription?: string; name?: string; pictureUrl?: string; price?: number; pimpleName?: string; sourceId?: string; type?: string; url?: string; badge?: Badge; weeePrices?: WEEEPrices; commercialStatus?: CommercialStatus; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productsFeed": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsFeed",
          "resolved": "FeedProduct[]",
          "references": {
            "ProductsFeed": {
              "location": "import",
              "path": "../../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CommerceConnectorSettings",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
}
